// // // Du Server BaseURL
export const BaseUrl = "https://avayaucg.inaipi.me/v1";
export const excelDownloadUrl = "https://avayauce.inaipi.me/files";
export const ticketUrl = "https://avayaucj.inaipi.me/ticketing";
export const errorApi = "https://avayaucj.inaipi.me/logs/v1";
export const SocketUrl = "https://avayaucj.inaipi.me";
export const AvcUrl = "https://avayaucj.inaipi.me/voicev2/voicechat";
export const AvcUrlagmc = "https://clouducg.inaipi.me/voiceagmc/voicechat";
export const CoBroswseUrl =
  "https://surfly.com/v2/sessions/?api_key=3ea557f1ea1a4814ae0184a5dafb121b";
export const Realtime_BaseUrl =
  "https://avayaucj.inaipi.me/rtdservice/#/IndividualAgentDashboard";
export const newBaseUrlLang = "https://avayaucg.inaipi.me/";
export const TenantID = "123456";
export const fileservice = "https://avayaucj.inaipi.me/upload/v1";
export const emailservice = "https://avayaucj.inaipi.me/email/";
export const BaseUrlSurvey = "https://cms.inaipiapp.com/DccSurvey/public/api";
export const VoiceDomainName = "ucd.inaipi.me";
export const VoiceDomainNameagmc = "albatha.com";
export const VoiceDomainNamePure = "purecs.inaipi.me";
export const PowerBiurl = "https://avayaucj.inaipi.me/publicservice/";
export const PortalUrl = "https://avayaucj.inaipi.me/publicservice";
export const BaseUrlReports = "https://avayaucj.inaipi.me/powerbi/";
export const Smartx_BaseUrl = "https://avayaistc.inaipi.me:8443/smartx/api";
export const VeichleBaseUrl = "https://avayaucj.inaipi.me/agmcfetch/api/v1";
export const Bulk_SMS =
  "https://cep.inaipiapp.com/sms_new/public/index.php/login";
export const Recording_Link =
  "http://10.225.142.182/Inaipicallrecording/login.aspx";
export const CMS = "https://inaipi.ae/galadari/login";
export const Survey = "https://cep.inaipiapp.com/DccSurveyapp/public/login";
export const ACCS_Report = "http://10.225.142.182/galadari/index.php";
export const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const versionCode = "DCC 2.0";
export const logoutTime = 7200000;
export const fileSizeCofig = 5000000;
export const MsgSizeCofig = 3000;
export const wsUri = "ws://127.0.0.1:3030/";
export const AesToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJXU0RNQ0MiLCJuYW1lIjoiSW5haXBpIiwiaWF0IjoxNTE2MjM5MDIyfQ.Ijrw_RLIujqDfV5n6V4-7vOFnRMCZSTkHnTthg2Am1A";
